'use client'

import { createContext } from 'react'

import type { LicenseMapCategory } from './license-map-types'

export interface LicenseMapFilter {
  /** Categories the legend has switched off; the map dims them, the table hides them. */
  off: LicenseMapCategory[]
  toggle: (category: LicenseMapCategory) => void
}

// The default is what LicenseMapLegend sees while it renders inside the
// Suspense fallback, before LicenseMapInteractive (the provider) has loaded:
// nothing filtered, toggles ignored.
export const LicenseMapFilterContext = createContext<LicenseMapFilter>({ off: [], toggle: () => {} })
